// TODO
export const getDates = str => {
  if (!str || new Date(str) == 'Invalid Date') {
    return false
  }
  let time_end = new Date(str)
  let time_now = new Date()
  return (time_end.getTime() - time_now.getTime()) / 24 / 60 / 60 / 1000 < 30
}
